import { render, staticRenderFns } from "./datosAcceso.vue?vue&type=template&id=2bea1b27"
import script from "./datosAcceso.vue?vue&type=script&lang=js"
export * from "./datosAcceso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports